module.exports = __webpack_public_path__ + "static/media/Desktop_WhatIsCulture_12.2abca831.png";